"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _times2 = _interopRequireDefault(require("lodash/times"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSkeletonLoading = _interopRequireDefault(require("@nerdwallet/react-skeleton-loading"));
var _skeletonKetoProductCardModule = _interopRequireDefault(require("./skeleton-keto-product-card.module.css"));
var SkeletonKetoProductCard = function SkeletonKetoProductCard(_ref) {
  var className = _ref.className,
    _ref$driverAmount = _ref.driverAmount,
    driverAmount = _ref$driverAmount === void 0 ? 4 : _ref$driverAmount,
    largeDriver = _ref.largeDriver;
  return /*#__PURE__*/_react.default.createElement(_reactSkeletonLoading.default, {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.header
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.body
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.imageRatingContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.imageCtaContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.image
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.cta
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.ratingContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.rating
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.ratingLink
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.driversContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.driversLabelsContainer
  }, (0, _times2.default)(driverAmount, function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: largeDriver ? _skeletonKetoProductCardModule.default.largeDriver : _skeletonKetoProductCardModule.default.driver
    });
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.driversContentContainer
  }, (0, _times2.default)(driverAmount, function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: largeDriver ? _skeletonKetoProductCardModule.default.largeDriver : _skeletonKetoProductCardModule.default.driver
    });
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.accordionContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.accordion
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _skeletonKetoProductCardModule.default.accordion
  }))));
};
SkeletonKetoProductCard.propTypes = {
  className: _propTypes.default.string,
  driverAmount: _propTypes.default.number,
  largeDriver: _propTypes.default.bool
};
SkeletonKetoProductCard.displayName = 'SkeletonKetoProductCard';
var _default = SkeletonKetoProductCard;
exports.default = _default;